module.exports = __webpack_public_path__ + "img/TmenzhenB.0e065375.svg";